/**
 * Dashboard aggregate request (F10).
 *
 * Split from the hook so a test can stub the request by spying on this module —
 * a hook that called a function defined in its own module could not be
 * intercepted, because the internal reference does not go through the export.
 *
 * Lives in `lib/` because two features consume the dashboard aggregate — the
 * dashboard screen and the analytics screen — and plan §3.1 forbids one feature
 * importing another feature's api.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md tasks 7.16, 7.19, §3.1
 */
import type { Dashboard } from '@nexus/contracts';

import { api } from './api-client';

export async function getDashboard(): Promise<Dashboard> {
  return api.get<Dashboard>('/dashboard');
}
